import localDB from "../data/localDB";

let GLOBAL = require('../data/globals');

const DataService = {
    post(data, url, res) {
        fetch(`${GLOBAL.BASE_URL}${url}`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': localDB.sessionToken()
            },
            body: JSON.stringify(data)
        }).then((response) => response.json()).then((responseData) => res(responseData)).catch((err) => {
            console.log(err);
            res(null)
        });
    },
    put(data, url, res) {
        fetch(`${GLOBAL.BASE_URL}${url}`, {
            method: 'PUT',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': localDB.sessionToken()
            },
            body: JSON.stringify(data)
        }).then((response) => response.json()).then((responseData) => res(responseData)).catch((err) => {
            console.log(err);
            res(null)
        });
    },
    delete(url, res) {
        fetch(`${GLOBAL.BASE_URL}${url}`, {
            method: 'DELETE',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': localDB.sessionToken()
            }
        }).then((response) => response.json()).then((responseData) => res(responseData)).catch((err) => res(null));
    },
    async get(url, params='') {
        let headers = {'Authorization': localDB.sessionToken()}
        if(params !== ''){
            params = Object.entries(params).map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`).join('&');
            if(params.includes('without_auth')){
                delete headers["Authorization"];
            }
        }

        let response = await fetch(`${GLOBAL.BASE_URL}${url}?${params}`, {
            method: 'GET',
            headers
        });


        return await response.json();
    },
};

export default DataService;



// WEBPACK FOOTER //
// ./src/functions/DataService.js